module.exports = __webpack_public_path__ + "img/50_22.7a98b906.png";